import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environments/environment.model';
import { signalStoreCustomerRequestOptions } from '../../../shared/interceptors/signal-store-customer-context';
import {
  CropFieldSnapshot,
  GreenManureAnswers,
  GreenManureContext,
  GreenManureQuestionnaire,
} from './green-manure.model';

@Injectable({ providedIn: 'root' })
export class GreenManureApiService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  getQuestionnaire(context: GreenManureContext) {
    return this.http.get<GreenManureQuestionnaire | null>(
      this.url(context),
      signalStoreCustomerRequestOptions(context.customerId),
    );
  }

  saveQuestionnaire(context: GreenManureContext, answers: GreenManureAnswers, cropFieldSnapshot?: CropFieldSnapshot) {
    return this.http.put<void>(
      this.url(context),
      { ...answers, cropFieldSnapshot },
      signalStoreCustomerRequestOptions(context.customerId),
    );
  }

  refreshSnapshot(context: GreenManureContext, cropFieldSnapshot: CropFieldSnapshot) {
    return this.http.post<void>(
      `${this.url(context)}/refresh-crop-field-snapshot`,
      { cropFieldSnapshot },
      signalStoreCustomerRequestOptions(context.customerId),
    );
  }

  private url(context: GreenManureContext): string {
    return `${this.env.APIM_BASE_URL}/arable-integration-service/green-manure-advice/questionnaire/${context.cropFieldId}/${context.cropYear}`;
  }
}
